import React, { useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import type { ICellRendererParams } from 'ag-grid-community';

import { getUiWorkspaceIsActiveContextMenuSelector } from '@/domain/ui';

import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import { IS_OPEN_CONTEXT_MENU_CLASS } from '@/components/AgGrid/Documents/agGridThemeClasses';

const ContextCellRenderer: React.FC<ICellRendererParams> = ({ data, colDef, context, eGridCell }) => {
  const isActiveContextMenu = useSelector(getUiWorkspaceIsActiveContextMenuSelector);
  const { id } = data;
  const {
    components: {
      [colDef!.cellRenderer as string]: { oncClickContextMenu },
    },
  } = context;

  const handleClick = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      oncClickContextMenu(e, id);
      eGridCell.classList.add(IS_OPEN_CONTEXT_MENU_CLASS);
    },
    [id, oncClickContextMenu, eGridCell],
  );

  useEffect(() => {
    if (!isActiveContextMenu) {
      eGridCell.classList.remove(IS_OPEN_CONTEXT_MENU_CLASS);
    }
  }, [isActiveContextMenu, eGridCell]);

  return (
    <Stack
      justifyContent="center"
      alignItems="center"
      flex={1}
      height="100%"
      sx={{
        // visible only on row hover or while menu is open
        opacity: 0,
        [`.ag-row-hover &, .${IS_OPEN_CONTEXT_MENU_CLASS} &`]: { opacity: 1 },
      }}
    >
      <IconButton onClick={handleClick} sx={{ fontSize: '22px' }}>
        <MoreHorizIcon fontSize="inherit" />
      </IconButton>
    </Stack>
  );
};

export default ContextCellRenderer;
